import React, { useState } from 'react'
import { Autocomplete, AutocompleteProps } from '@mui/material'
import * as R from 'ramda'

import { Field, IdObject } from '../../types'
import { getTranslatedFieldName } from '../../utils/languageUtils'
import PuiTextField from './PuiTextField'

export interface PuiAutocompleteSelectProps
  extends AutocompleteProps<any, any, any, any> {
  readonly field: Field
  readonly label: React.ReactNode
  readonly options: IdObject[]
}

const PuiAutocompleteSelect = ({
  field,
  label,
  options: optionsProp,
  renderInput,
  ...rest
}: PuiAutocompleteSelectProps) => {
  const options = optionsProp || []

  const [open, setOpen] = useState(false)

  const textInputField = {
    ...field,
    set: R.F,
    setValue: R.F,
  }

  return (
    <Autocomplete
      getOptionLabel={option => getTranslatedFieldName(option)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      open={open}
      options={options}
      renderInput={
        renderInput ||
        (params => (
          <PuiTextField field={textInputField} label={label} {...params} />
        ))
      }
      value={options.find(({ id }) => id === field.value) || null}
      onChange={(event, item) => field.setValue(item?.id || '')}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      {...rest}
    />
  )
}

export default PuiAutocompleteSelect
